var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content__container"},[_c('aside',{class:_vm.asideClass},[_c('div',{staticClass:"aside__content"},[_vm._t("sidebar")],2)]),_c('main',{staticClass:"main"},[_vm._t("main")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }